import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { DataResultType, usePostQuestionMutation } from '../store/services/dataservice';
import { selectUserId } from '../store/features/authSlice';
import { selectDataChatLastId, setQuestions } from '../store/features/chatbotSlice';

export const useDataChatbot = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const email = useSelector(selectUserId)
    const divId = useSelector(selectDataChatLastId)
    const key = location.pathname.replace('/', '')
    const [postQuestion] = usePostQuestionMutation<DataResultType>()

    const queryDataChatbot = async (query: string | null) => {
        if (!query) return

        dispatch(setQuestions({key, value: query}))

        postQuestion({ email, query })
        if (divId) {
            setTimeout(() => {
                document.getElementById(divId)?.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest"
                });
            }, 3000)
        }
    }

    return { queryDataChatbot }
}
